export class Org {
    constructor(public cUid: any[]) { }
}